






















import { defineComponent, PropType } from "@vue/composition-api";
import { LiveChatInvitation } from "@scrile/api-provider/dist/api/LivechatsProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "PrivateInvitationItem",
  components: { BaseButton, BaseAvatar },
  props: {
    invitation: { type: Object as PropType<LiveChatInvitation>, required: true },
  },
});
